import { cl, CustomElement } from '@/utils';

export default class Tabs extends CustomElement {
  static component = 'b-tabs';
  static observedAttributes = ['active'];
  triggers: HTMLElement[] = [];
  tabs: HTMLElement[] = [];
  dropdowns: any[] = [];

  init() {
    this.triggers = this.$$('tab-trig');
    this.tabs = this.$$('tab');
    this.dropdowns = this.$$('dropdown');

    this.triggers.forEach((el) => {
      el.addEventListener('click', () => {
        const tabName = el.getAttribute('data-tab');
        if (tabName) {
          this.dropdowns.forEach((el) => {
            el.value = tabName;
          });
          this.setAttribute('active', tabName);
        }
      });
    });

    this.dropdowns.forEach((el) => {
      el.addEventListener('sl-change', (e) => {
        this.setAttribute('active', e.target.value);
      });
    });
  }

  changed(name: string, val: string) {
    if (name === 'active') {
      const tab = this.tabs.find((el) => el.getAttribute('data-tab') === val);
      const trigger = this.triggers.find((el) => el.getAttribute('data-tab') === val);

      if (tab) {
        cl(this.tabs).remove('active');
        cl(tab).add('active');
      }

      if (trigger) {
        cl(this.triggers).remove('active');
        cl(trigger).add('active');
      }
    }
  }
}
